import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { isProduction } from "_metronic/_helpers";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "app/modules/Auth/_redux/authRedux";
import {
  Image
} from "react-bootstrap"
import { toAbsoluteUrl } from "_metronic/_helpers";

import { login } from "api/authenticate"

const initialValues = isProduction() ? { } : {
  email: "admin@stakecare.com.br",
  password: "stakecare",
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [logoUrl] = useState( process.env.REACT_APP_LOGO ? toAbsoluteUrl(`/media/logos/${process.env.REACT_APP_LOGO}`) : null )

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({id:"AUTH.VALIDATION.INVALID_EMAIL"}))
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(4, intl.formatMessage({id:"AUTH.VALIDATION.MIN_LENGTH_FIELD"}, {value:4}))
      .max(20, intl.formatMessage({id:"AUTH.VALIDATION.MAX_LENGTH_FIELD"}, {value:20}))
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const enableLoading   = () => setLoading(true)
  const disableLoading  = () => setLoading(false)

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(() => {
        login(values.email, values.password)
          .then(({user}) => {
            props.login(user.uid);
          })
          .catch(error => {
            disableLoading();
            setSubmitting(false);
            setStatus(
              intl.formatMessage({id: `FIREBASE.AUTH.${error.code}`})
            );
          });
      }, 500);
    },
  });

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        {
          (logoUrl) && <Image src={logoUrl} style={{objectFit:"contain", width:"100%", height:75, marginBottom:10}} />
        }
        <h3 className="font-size-h1 my-2">
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </h3>
        <p className="text-muted font-weight-bold">
          <FormattedMessage id="AUTH.LOGIN.SUBTITLE" />
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : (null)}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Email"
            type="email"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "email"
            )}`}
            name="email"
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.email}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Password"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
          </Link>
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
          >
            <FormattedMessage id="AUTH.LOGIN.BUTTON" />
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
